// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"99bb1374","703":"7b16a44d"}[chunkId] + ".chunk.js";
};